import { TrFun } from "./types";

export function renderRequiredMessage(id: string, t: TrFun) {
	return `${t(id)} ${t("is-required-field")}`;
}
